import {ReactNode, useState} from "react";

export type ConfirmationPopupFunction = (
  title: string,
  description: string | ReactNode,
  actionText: string,
  onAccept: (metadata?: { [key: string]: any }) => void,
  onCancel?: (metadata?: { [key: string]: any }) => void,
  metadata?: { [key: string]: any },
) => void;

type ConfirmationData = {
  title: string,
  description: string | ReactNode,
  actionText: string,
  onAccept: (metadata?: { [key: string]: any }) => void,
  onCancel?: (metadata?: { [key: string]: any }) => void,
}

export function useConfirmationPopupFunction(
  openConfirmationDialog: (metadata?: { [key: string]: any }) => void
): [ConfirmationData, ConfirmationPopupFunction] {

  const [confirmationData, setConfirmationData] = useState<ConfirmationData>({ title: '', description: '', actionText: '', onAccept: () => {}, onCancel: () => {} });

  const handleOpenConfirmationPopup: ConfirmationPopupFunction = (
    title: string,
    description: string | ReactNode,
    actionText: string,
    onAccept: (metadata?: { [key: string]: any }) => void,
    onCancel?: (metadata?: { [key: string]: any }) => void,
    metadata?: { [key: string]: any },
  ) => {
    setConfirmationData({ title, description, actionText, onAccept, onCancel });
    openConfirmationDialog(metadata);
  }
  return [ confirmationData, handleOpenConfirmationPopup ];
}
